module.exports = "/_next/static/images/duck-189a3e7b774faa5baa6479ad038a706e.png";